import '../../../css/create-installer-view.scss';
import { ReactComponent as UploadIcon } from "../../../images/icons/upload.svg";
import React, {useState} from "react";

export default function CreateInstallerView({setCreateInstallerViewOpen, mode})
{
    const [name, setName] = useState(null);
    const [clientId, setClientId] = useState(null);
    const [installationId, setInstallationId] = useState(null);
    const [file, setFile] = useState(null);
    const [loading, setLoading] = useState(false)

    function submitNewInstaller()
    {
        if(!(name || clientId || installationId || file)) return;

        setLoading(true);

        const reader = new FileReader();

        reader.onload = (e) => {
            const data = {
                installerId: name,
                token: e.target.result,
                clientId: clientId,
                installationId: installationId,
            }

            fetch("admin/api/new-github-installer", {
                    credentials: "include",
                    method: "POST",
                    headers: { "Content-Type": 'application/json' },
                    body: JSON.stringify(data),
                }
            )
            .then(res =>
            {
                if(res.ok) window.location.reload()
                else
                {
                    console.error(res.statusMessage);
                    alert(res.statusMessage);
                }
            })
            .finally(() => setLoading(false));
        };

        reader.readAsText(file);
    }

    return (
        mode === "github" && (
        <div id="priv-github" className="create-installer-view">
            {
                loading && (
                    <div className="loading-overlay">
                        <div className="loading-circle"></div>
                    </div>
                )
            }
            <div className="create-installer-header">Github App Installer</div>
            <label htmlFor="github-installer-id-input">Installer Name</label>
            <input id="github-installer-id-input" type="text" className="glass-input" onChange={(e) => setName(e.target.value)}/>

            <label htmlFor="github-installer-client-input">Client ID</label>
            <input id="github-installer-client-input" type="text" className="glass-input" onChange={(e) => setClientId(e.target.value)}/>

            <label htmlFor="github-installer-installation-input">Installation ID</label>
            <input id="github-installer-installation-input" type="text" className="glass-input" onChange={(e) => setInstallationId(e.target.value)}/>

            <div className="upload-field">
                <label htmlFor="github-installer-pem-input">PEM Key<UploadIcon className={"upload-button" + (file != null ? " upload-fulfilled" : "")}/></label>
                <input id="github-installer-pem-input" className="hidden" type="file" accept=".pem" onChange={(e) => setFile(e.target.files[0])}/>
                <div className="install-button-group">
                    <div
                        id="new-installer-close"
                        className={"submit-button"}
                        onClick={() => setCreateInstallerViewOpen(false)}
                    >
                        Cancel
                    </div>
                    <div
                        id="new-github-installer-button"
                        className={"submit-button" + (name && clientId && installationId && file ? "" : " disabled")}
                        onClick={() => submitNewInstaller()}
                    >
                        Submit
                    </div>
                </div>
            </div>


        </div>
        )
    );
}